/**
 * @graph-stack product-innovation-lab
 * @graph-domain UX
 * @graph-business ルートパス。認証後 portalRole=member/external は /my-page（IDチーム所属は /members/idt-kpi）、PDG/ACE の他ロールは /kpi にリダイレクト
 * @graph-connects useAuth [calls] 認証状態から portalRole / teamName を取得しデフォルトページを決定
 */
import { useEffect, useRef } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useAuth } from '../hooks/useAuth.js';
import { defaultRouteForRole } from '../lib/default-route.js';
import { LoadingScreen } from '../components/feedback/LoadingScreen/index.js';

/** @graph-connects none */
export const Route = createFileRoute('/')({
  component: IndexRedirect,
});

/** @graph-connects none */
function IndexRedirect() {
  const { user, isAuthenticated, isLoading } = useAuth();
  const navigate = useNavigate();
  // 認証完了後の redirect は 1 回しか撃たない。auth state が transition 中に
  // 多重に変動して effect が再発火しても navigate は再呼び出ししない。
  // 連続 navigate は TanStack Router Transitioner の setIsTransitioning を
  // 連発させ React の setState 上限を超えて Minified React error #185 を起こす
  // （docs/web/product-innovation-lab.md, PR #368）。
  const navigatedRef = useRef(false);

  useEffect(() => {
    if (navigatedRef.current) return;
    if (isLoading || !isAuthenticated) return;
    navigatedRef.current = true;
    void navigate({ to: defaultRouteForRole(user?.portalRoles, user?.teamName), replace: true });
  }, [isLoading, isAuthenticated, user?.portalRoles, user?.teamName, navigate]);

  return <LoadingScreen />;
}
